import { useEffect, useState } from "react"
import Input from "../../../components/Input"
import Map from "../../../components/Map"
import Popup from "../../../components/Popup"
import Select from "../../../components/Select"
import { authAxios } from "../../../helpers/axios"
import ImageInput from "../../../components/ImageInput"
import MultiSelect from 'react-select';
import CropPopup from "../../../components/CropPopup"
import { COUNTRIES, RETAILER_IMAGE_BASE_URL } from "../../../helpers/constants"

export default function ManageSupplier({onClose,edit=false,onSubmit,updateData})
{
    const [manageData,setManageData] = useState(!edit ? {name:'',contactNumber:'',contactPerson:'',contactEmail:'',address:'',status:1,gstPercentage:'',state:'',gst:'',hsn:''} : {...updateData,name:updateData.name,contactNumber:updateData.contactNumber,contactPerson:updateData.contactPerson,contactEmail:updateData.contactEmail,status:updateData.status,gst:updateData.gst,gstPercentage:updateData.gstPercentage,state:updateData.state,hsn:updateData.hsn})
    const [cities,setCities] = useState([])
    const [routes,setRoutes] = useState([])
    const [distributors,setDistributors] = useState([])
    const [showCrop,setShowCrop] = useState(false)
    const formName = 'editRetailer';
    const [image,setImage] = useState(null)
    const [croppedImage,setCroppedImage] = useState()



    return <><Popup size="sm" title={edit ? 'Update Supplier' : 'Create Supplier'} submitTitle={edit ? 'Update' : 'Create'} onClose={onClose} formName={formName}>
        <form onSubmit={(e)=>onSubmit(e,{...manageData})} id={formName} className='w-full'>
            <div className="col-span-4">
                    {/* <ImageInput image={manageData.retailerImage && manageData.retailerImage!=='' ? `${manageData.retailerImage}` : image} setImage={onImageChange} /> */}
                </div>
                <div className="block grid-cols-2 gap-x-3 gap-y-0 w-full">
            <div className="grid grid-cols-4 gap-x-3 gap-y-0 w-full">
            <div className="col-span-2">
                <label>Supplier Name</label>
                <Input type='text' placeholder={'Enter Supplier Name'} value={manageData.name} setValue={(value)=>setManageData(data=>({...data,name:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Contact Person</label>
                <Input type='text' placeholder={'Enter Contact Person'} value={manageData.contactPerson} setValue={(value)=>setManageData(data=>({...data,contactPerson:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Phone Number (+91)</label>
                <Input type='text' placeholder={'Enter Contact Number'} value={manageData.contactNumber} setValue={(value)=>setManageData(data=>({...data,contactNumber:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Status</label>
                <Select placeholder={'Select Status'} options={[{name:'Active',value:1},{name:'Inactive',value:0}]}  value={manageData.status} setValue={(value)=>setManageData(data=>({...data,status:value}))}/>
            </div>
            <div className="col-span-2">
                <label>HSN/SAC</label>
                <Input type='text' placeholder={'Enter HSN'} value={manageData.hsn} setValue={(value)=>setManageData(data=>({...data,hsn:value}))}/>
            </div>
            <div className="col-span-2">
                <label>GST</label>
                <Input type='text' placeholder={'Enter GST'} value={manageData.gst} setValue={(value)=>setManageData(data=>({...data,gst:value}))}/>
            </div>
            <div className="col-span-2">
                <label>GST Percentage</label>
                <Input type='number' placeholder={'Enter GST Percentage'} value={manageData.gstPercentage} setValue={(value)=>setManageData(data=>({...data,gstPercentage:value}))}/>
            </div>
            <div className="col-span-2">
                <label>Address</label>
                <textarea className="h-[40px] w-full text-input mb-4 font-medium leading-normal" placeholder={'Enter Address'} value={manageData.address} onChange={(e)=>setManageData(data=>({...data,address:e.target.value}))}/>
            </div>
            <div className="col-span-2">
                <label>City</label>
                <Input type='text' placeholder={'Enter City'} value={manageData.city} setValue={(value)=>setManageData(data=>({...data,city:value}))}/>
            </div>
            <div className="col-span-2">
                <label>State</label>
                <Input type='text' placeholder={'Enter State'} value={manageData.state} setValue={(value)=>setManageData(data=>({...data,state:value}))}/>
            </div>
            </div>
            </div>
        </form>
    </Popup>
    {showCrop ? <CropPopup image={image} setActive={setShowCrop} setImage={setCroppedImage}/>: null}
    </>
}